var Bluff = (window.Bluff = {
    VERSION: '0.3.6',
    array: function (list) {
        if (list.length === undefined) return [list];
        var ary = [],
            i = list.length;
        while (i--) ary[i] = list[i];
        return ary;
    },
    array_new: function (length, filler) {
        var ary = [];
        while (length--) ary.push(filler);
        return ary;
    },
    each: function (list, block, context) {
        for (var i = 0, n = list.length; i < n; i++) block.call(context || null, list[i], i);
    },
    index: function (list, needle) {
        for (var i = 0, n = list.length; i < n; i++) if (list[i] === needle) return i;
        return -1;
    },
    keys: function (object) {
        var ary = [],
            key;
        for (key in object) ary.push(key);
        return ary;
    },
    map: function (list, block, context) {
        var results = [];
        this.each(list, function (item) {
            results.push(block.call(context || null, item));
        });
        return results;
    },
    reverse_each: function (list, block, context) {
        var i = list.length;
        while (i--) block.call(context || null, list[i], i);
    },
    sum: function (list) {
        var sum = 0,
            i = list.length;
        while (i--) sum += list[i];
        return sum;
    },
    Mini: {},
});
Bluff.Base = new JS.Class({
    extend: {
        DEBUG: false,
        DATA_LABEL_INDEX: 0,
        DATA_VALUES_INDEX: 1,
        DATA_COLOR_INDEX: 2,
        LEGEND_MARGIN: 20,
        TITLE_MARGIN: 20,
        LABEL_MARGIN: 10,
        DEFAULT_MARGIN: 20,
        DEFAULT_TARGET_WIDTH: 800,
        THOUSAND_SEPARATOR: ',',
    },
    top_margin: null,
    bottom_margin: null,
    right_margin: null,
    left_margin: null,
    title_margin: null,
    legend_margin: null,
    labels: null,
    center_labels_over_point: null,
    has_left_labels: null,
    x_axis_label: null,
    y_axis_label: null,
    y_axis_increment: null,
    y_axis_skip: null,
    colors: null,
    title: null,
    font: null,
    font_color: null,
    hide_line_markers: null,
    hide_legend: null,
    hide_title: null,
    hide_line_numbers: null,
    no_data_message: null,
    title_font_size: null,
    legend_font_size: null,
    marker_font_size: null,
    marker_color: null,
    marker_count: null,
    minimum_value: null,
    maximum_value: null,
    sort: null,
    stacked: null,
    legend_box_size: null,
    tooltips: false,
    initialize: function (renderer, target_width) {
        this._d = new Bluff.Renderer(renderer);
        target_width = target_width || this.klass.DEFAULT_TARGET_WIDTH;
        var geo;
        if (typeof target_width !== 'number') {
            geo = target_width.split('x');
            this._columns = parseFloat(geo[0]);
            this._rows = parseFloat(geo[1]);
        } else {
            this._columns = parseFloat(target_width);
            this._rows = this._columns * 0.75;
        }
        this.initialize_ivars();
        this._reset_themes();
    },
    initialize_ivars: function () {
        this._raw_columns = 800;
        this._raw_rows = 800 * (this._rows / this._columns);
        this._column_count = 0;
        this.marker_count = null;
        this.maximum_value = this.minimum_value = null;
        this._has_data = false;
        this._data = [];
        this.labels = {};
        this._labels_seen = {};
        this.sort = true;
        this.title = null;
        this._scale = this._columns / this._raw_columns;
        this.marker_font_size = 21;
        this.legend_font_size = this.legend_box_size = 20;
        this.title_font_size = 36;
        this.top_margin = this.bottom_margin = this.left_margin = this.right_margin = this.klass.DEFAULT_MARGIN;
        this.legend_margin = this.klass.LEGEND_MARGIN;
        this.title_margin = this.klass.TITLE_MARGIN;
        this.left_margin = -10;
        this.no_data_message = 'No Data';
        this.hide_line_markers = this.hide_legend = this.hide_title = this.hide_line_numbers = false;
        this.center_labels_over_point = true;
        this.has_left_labels = false;
        this._additional_line_colors = [];
        this._theme_options = {};
        this.x_axis_label = this.y_axis_label = null;
        this.y_axis_increment = y_axis_skip = null;
        this.stacked = null;
        this._norm_data = null;
    },
    set_margins: function (margin) {
        this.top_margin = this.left_margin = this.right_margin = this.bottom_margin = margin;
    },
    set_font: function (font_path) {
        this.font = font_path;
        this._d.font = this.font;
    },
    add_color: function (colorname) {
        this.colors.push(colorname);
    },
    replace_colors: function (color_list) {
        this.colors = color_list || [];
        this._color_index = 0;
    },
    set_theme: function (options) {
        this._reset_themes();
        this._theme_options = {
            colors: ['black', 'white'],
            additional_line_colors: [],
            marker_color: 'white',
            font_color: 'black',
            background_colors: null,
            background_image: null,
        };
        for (var key in options) this._theme_options[key] = options[key];
        this.colors = this._theme_options.colors;
        this.marker_color = this._theme_options.marker_color;
        this.font_color = this._theme_options.font_color || this.marker_color;
        this._additional_line_colors = this._theme_options.additional_line_colors;
        this._render_background();
    },
    data: function (name, data_points, color) {
        data_points = data_points === undefined ? [] : data_points;
        color = color || null;
        data_points = Bluff.array(data_points);
        this._data.push([name, data_points, color || this._increment_color()]);
        this._column_count = data_points.length > this._column_count ? data_points.length : this._column_count;
        Bluff.each(
            data_points,
            function (data_point, index) {
                if (data_point === undefined) return;
                if (this.maximum_value === null && this.minimum_value === null)
                    this.maximum_value = this.minimum_value = data_point;
                this.maximum_value = this._larger_than_max(data_point) ? data_point : this.maximum_value;
                if (this.maximum_value >= 0) this._has_data = true;
                this.minimum_value = this._less_than_min(data_point) ? data_point : this.minimum_value;
                if (this.minimum_value < 0) this._has_data = true;
            },
            this
        );
    },
    draw: function () {
        if (this.stacked) this._make_stacked();
        this._setup_drawing();
        this._debug(function () {
            this._d.rectangle(
                this.left_margin,
                this.top_margin,
                this._raw_columns - this.right_margin,
                this._raw_rows - this.bottom_margin
            );
            this._d.rectangle(this._graph_left, this._graph_top, this._graph_right, this._graph_bottom);
        });
    },
    clear: function () {
        this._render_background();
    },
    _setup_drawing: function () {
        if (!this._has_data) return this._draw_no_data();
        this._normalize();
        this._setup_graph_measurements();
        if (this.sort) this._sort_norm_data();
        this._draw_legend();
        this._draw_line_markers();
        this._draw_axis_labels();
        this._draw_title();
    },
    _normalize: function (force) {
        if (this._norm_data === null || force === true) {
            this._norm_data = [];
            if (!this._has_data) return;
            this._calculate_spread();
            Bluff.each(
                this._data,
                function (data_row) {
                    var norm_data_points = [];
                    Bluff.each(
                        data_row[this.klass.DATA_VALUES_INDEX],
                        function (data_point) {
                            if (data_point === null || data_point === undefined) norm_data_points.push(null);
                            else norm_data_points.push((data_point - this.minimum_value) / this._spread);
                        },
                        this
                    );
                    this._norm_data.push([
                        data_row[this.klass.DATA_LABEL_INDEX],
                        norm_data_points,
                        data_row[this.klass.DATA_COLOR_INDEX],
                    ]);
                },
                this
            );
        }
    },
    _calculate_spread: function () {
        this._spread = this.maximum_value - this.minimum_value;
        this._spread = this._spread > 0 ? this._spread : 1;
        this._significant_digits = 100 / Math.pow(10, Math.round(Math.LOG10E * Math.log(this._spread)));
    },
    _setup_graph_measurements: function () {
        this._marker_caps_height = this.hide_line_markers ? 0 : this._calculate_caps_height(this.marker_font_size);
        this._title_caps_height = this.hide_title ? 0 : this._calculate_caps_height(this.title_font_size);
        this._legend_caps_height = this.hide_legend ? 0 : this._calculate_caps_height(this.legend_font_size);
        var longest_label,
            longest_left_label_width,
            line_number_width,
            last_label,
            extra_room_for_long_label,
            x_axis_label_height,
            key;
        if (this.hide_line_markers) {
            this._graph_left = this.left_margin;
            this._graph_right_margin = this.right_margin;
            this._graph_bottom_margin = this.bottom_margin;
        } else {
            longest_left_label_width = 0;
            if (this.has_left_labels) {
                longest_label = '';
                for (key in this.labels)
                    longest_label = longest_label.length > this.labels[key].length ? longest_label : this.labels[key];
                longest_left_label_width = this._calculate_width(this.marker_font_size, longest_label) * 1.25;
            } else
                longest_left_label_width = this._calculate_width(
                    this.marker_font_size,
                    this._label(this.maximum_value)
                );
            line_number_width =
                this.hide_line_numbers && !this.has_left_labels
                    ? 0
                    : longest_left_label_width + this.klass.LABEL_MARGIN * 2;
            this._graph_left =
                this.left_margin +
                line_number_width +
                (this.y_axis_label === null ? 0 : this._marker_caps_height + this.klass.LABEL_MARGIN * 2);
            last_label = -Infinity;
            for (key in this.labels) last_label = last_label > Number(key) ? last_label : Number(key);
            last_label = Math.round(last_label);
            extra_room_for_long_label =
                last_label >= this._column_count - 1 && this.center_labels_over_point
                    ? this._calculate_width(this.marker_font_size, this.labels[last_label]) / 2
                    : 0;
            this._graph_right_margin = this.right_margin + extra_room_for_long_label;
            this._graph_bottom_margin = this.bottom_margin + this._marker_caps_height + this.klass.LABEL_MARGIN;
        }
        this._graph_right = this._raw_columns - this._graph_right_margin;
        this._graph_width = this._raw_columns - this._graph_left - this._graph_right_margin;
        this._graph_top =
            this.top_margin +
            (this.hide_title ? this.title_margin : this._title_caps_height + this.title_margin) +
            (this.hide_legend ? this.legend_margin : this._legend_caps_height + this.legend_margin);
        x_axis_label_height = this.x_axis_label === null ? 0 : this._marker_caps_height + this.klass.LABEL_MARGIN;
        this._graph_bottom = this._raw_rows - this._graph_bottom_margin - x_axis_label_height;
        this._graph_height = this._graph_bottom - this._graph_top;
    },
    _draw_axis_labels: function () {
        if (this.x_axis_label) {
            var x_axis_label_y_coordinate = this._graph_bottom + this.klass.LABEL_MARGIN * 2 + this._marker_caps_height;
            this._d.fill = this.font_color;
            if (this.font) this._d.font = this.font;
            this._d.stroke = 'transparent';
            this._d.font_weight = 'normal';
            this._d.pointsize = this._scale_fontsize(this.marker_font_size);
            this._d.gravity = 'north';
            this._d.annotate_scaled(this._raw_columns, 1, 0, x_axis_label_y_coordinate, this.x_axis_label, this._scale);
            this._debug(function () {
                this._d.line(0, x_axis_label_y_coordinate, this._raw_columns, x_axis_label_y_coordinate);
            });
        }
    },
    _draw_line_markers: function () {
        if (this.hide_line_markers || this.hide_xaxis_line_markers) return;
        if (this.y_axis_increment === null) {
            if (this.marker_count === null) {
                Bluff.each(
                    [2, 3, 4, 5, 6, 7],
                    function (lines) {
                        if (!this.marker_count && this._spread % lines === 0) this.marker_count = lines;
                    },
                    this
                );
                this.marker_count = this.marker_count || 4;
            }
            this._increment = this._spread > 0 ? Math.round(this._significant(this._spread / this.marker_count)) : 1;
        } else {
            this.maximum_value = Math.max(Math.ceil(this.maximum_value), this.y_axis_increment);
            this.minimum_value = Math.floor(this.minimum_value);
            this._calculate_spread();
            this._normalize(true);
            this.marker_count = Math.round(this._spread / this.y_axis_increment);
            this._increment = this.y_axis_increment;
        }
        this._increment_scaled = this._graph_height / (this._spread / this._increment);
        var index, n, y, marker_label;
        for (index = 0, n = this.marker_count; index <= n; index++) {
            y = this._graph_top + this._graph_height - index * this._increment_scaled;
            this._d.stroke = this.marker_color;
            this._d.stroke_width = 1;
            this._d.line(this.klass.LABEL_MARGIN + 10, y, this._graph_right, y);
            marker_label = index * this._increment + this.minimum_value;
            if (!this.hide_line_numbers) {
                this._d.fill = this.font_color;
                if (this.font) this._d.font = this.font;
                this._d.font_weight = 'normal';
                this._d.stroke = 'transparent';
                this._d.pointsize = this._scale_fontsize(this.marker_font_size);
                this._d.gravity = 'east';

                this._d.annotate_scaled(this.klass.LABEL_MARGIN, 1, 0, y, this._label(marker_label), this._scale);
            }
        }
    },
    _center: function (size) {
        return (this._raw_columns - size) / 2;
    },
    _draw_legend: function () {
        if (this.hide_legend) return;
        this._legend_labels = Bluff.map(
            this._data,
            function (item) {
                return item[this.klass.DATA_LABEL_INDEX];
            },
            this
        );
        var legend_square_width = this.legend_box_size;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this.legend_font_size;
        var label_widths = [[]];
        Bluff.each(
            this._legend_labels,
            function (label) {
                var last = label_widths.length - 1;
                var metrics = this._d.get_type_metrics(label);
                var label_width = metrics.width + legend_square_width * 2.7;
                label_widths[last].push(label_width);
                if (Bluff.sum(label_widths[last]) > this._raw_columns * 0.9)
                    label_widths.push([label_widths[last].pop()]);
            },
            this
        );
        var current_x_offset = this._center(Bluff.sum(label_widths[0]));
        var current_y_offset = this.hide_title
            ? this.top_margin + this.title_margin
            : this.top_margin + this.title_margin + this._title_caps_height;
        this._debug(function () {
            this._d.stroke_width = 1;
            this._d.line(0, current_y_offset, this._raw_columns, current_y_offset);
        });
        Bluff.each(
            this._legend_labels,
            function (legend_label, index) {
                this._d.fill = this.font_color;
                if (this.font) this._d.font = this.font;
                this._d.pointsize = this._scale_fontsize(this.legend_font_size);
                this._d.stroke = 'transparent';
                this._d.font_weight = 'normal';
                this._d.gravity = 'west';
                this._d.annotate_scaled(
                    this._raw_columns,
                    1,
                    current_x_offset + legend_square_width * 1.7,
                    current_y_offset,
                    legend_label,
                    this._scale
                );
                this._d.stroke = 'transparent';
                this._d.fill = this._data[index][this.klass.DATA_COLOR_INDEX];
                this._d.rectangle(
                    current_x_offset,
                    current_y_offset - legend_square_width / 2,
                    current_x_offset + legend_square_width,
                    current_y_offset + legend_square_width / 2
                );
                this._d.pointsize = this.legend_font_size;
                var metrics = this._d.get_type_metrics(legend_label);
                var current_string_offset = metrics.width + legend_square_width * 2.7,
                    line_height;
                label_widths[0].shift();
                if (label_widths[0].length == 0) {
                    this._debug(function () {
                        this._d.line(0, current_y_offset, this._raw_columns, current_y_offset);
                    });
                    label_widths.shift();
                    if (label_widths.length > 0) current_x_offset = this._center(Bluff.sum(label_widths[0]));
                    line_height = Math.max(this._legend_caps_height, legend_square_width) + this.legend_margin;
                    if (label_widths.length > 0) {
                        current_y_offset += line_height;
                        this._graph_top += line_height;
                        this._graph_height = this._graph_bottom - this._graph_top;
                    }
                } else current_x_offset += current_string_offset;
            },
            this
        );
        this._color_index = 0;
    },
    _draw_title: function () {
        if (this.hide_title || !this.title) return;
        this._d.fill = this.font_color;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this._scale_fontsize(this.title_font_size);
        this._d.font_weight = 'normal';
        this._d.gravity = 'west';
        this._d.annotate_scaled(this._raw_columns, 1, 0, this.top_margin, this.title, this._scale);
    },
    _draw_label: function (x_offset, index) {
        if (this.hide_line_markers) return;
        var y_offset;
        var yarr = this.labels[index].split('#');
        for (var i = 0; i < yarr.length; i++)
            if (yarr[i]) {
                y_offset = this._graph_bottom + this.klass.LABEL_MARGIN;
                if (this.font) this._d.font = this.font;
                this._d.stroke = 'transparent';
                this._d.font_weight = 'normal';
                this._d.pointsize = this._scale_fontsize(this.marker_font_size);
                this._d.gravity = 'north';
                if (i == 1) {
                    this._d.fill = this.font_color;
                    this._d.annotate_scaled(1, 1, x_offset, y_offset + 14, yarr[i], this._scale);
                } else {
                    this._d.fill = '#a2a2a2';
                    this._d.annotate_scaled(1, 1, x_offset, y_offset - 5, yarr[i], this._scale);
                }
                this._labels_seen[index] = true;
                this._debug(function () {
                    this._d.stroke_width = 1;
                    this._d.line(0, y_offset, this._raw_columns, y_offset);
                });
            }
    },
    _draw_tooltip: function (left, top, width, height, name, color, data) {
        if (!this.tooltips) return;
        this._d.tooltip(left, top, width, height, name, color, data);
    },
    _draw_no_data: function () {
        this._d.fill = this.font_color;
        if (this.font) this._d.font = this.font;
        this._d.stroke = 'transparent';
        this._d.font_weight = 'normal';
        if (this._scale < 1) this._d.pointsize = this._scale_fontsize(80);
        else this._d.pointsize = this._scale_fontsize(20);
        this._d.gravity = 'center';
        this._d.annotate_scaled(this._raw_columns, this._raw_rows / 2, 0, 10, this.no_data_message, this._scale);
    },
    _render_background: function () {
        var colors = this._theme_options.background_colors;
        switch (true) {
            case colors instanceof Array:
                this._render_gradiated_background.apply(this, colors);
                break;
            case typeof colors === 'string':
                this._render_solid_background(colors);
                break;
            default:
                this._render_image_background(this._theme_options.background_image);
                break;
        }
    },
    _render_solid_background: function (color) {
        this._d.render_solid_background(this._columns, this._rows, color);
    },
    _render_gradiated_background: function (top_color, bottom_color) {
        this._d.render_gradiated_background(this._columns, this._rows, top_color, bottom_color);
    },
    _render_image_background: function (image_path) {},
    _reset_themes: function () {
        this._color_index = 0;
        this._labels_seen = {};
        this._theme_options = {};
        this._d.scale(this._scale, this._scale);
    },
    _scale_value: function (value) {
        return this._scale * value;
    },
    _scale_fontsize: function (value) {
        var new_fontsize = value * this._scale;
        return new_fontsize;
    },
    _clip_value_if_greater_than: function (value, max_value) {
        return value > max_value ? max_value : value;
    },
    _larger_than_max: function (data_point, index) {
        return data_point > this.maximum_value;
    },
    _less_than_min: function (data_point, index) {
        return data_point < this.minimum_value;
    },
    _max: function (data_point, index) {
        return data_point;
    },
    _min: function (data_point, index) {
        return data_point;
    },
    _significant: function (inc) {
        if (inc == 0) return 1;
        var factor = 1;
        while (inc < 10) {
            inc *= 10;
            factor /= 10;
        }
        while (inc > 100) {
            inc /= 10;
            factor *= 10;
        }
        return Math.floor(inc) * factor;
    },
    _sort_norm_data: function () {
        var sums = this._sums,
            index = this.klass.DATA_VALUES_INDEX;
        this._norm_data.sort(function (a, b) {
            return sums(b[index]) - sums(a[index]);
        });
        this._data.sort(function (a, b) {
            return sums(b[index]) - sums(a[index]);
        });
    },
    _sums: function (data_set) {
        var total_sum = 0;
        Bluff.each(data_set, function (num) {
            total_sum += num || 0;
        });
        return total_sum;
    },
    _make_stacked: function () {
        var stacked_values = [],
            i = this._column_count;
        while (i--) stacked_values[i] = 0;
        Bluff.each(
            this._data,
            function (value_set) {
                Bluff.each(
                    value_set[this.klass.DATA_VALUES_INDEX],
                    function (value, index) {
                        stacked_values[index] += value;
                    },
                    this
                );
                value_set[this.klass.DATA_VALUES_INDEX] = Bluff.array(stacked_values);
            },
            this
        );
    },
    _debug: function (block) {
        if (this.klass.DEBUG) {
            this._d.fill = 'transparent';
            this._d.stroke = 'turquoise';
            block.call(this);
        }
    },
    _increment_color: function () {
        if (this._color_index < this.colors.length) this._color_index += 1;
        else this._color_index = 0;
        var offset = this._color_index == 0 ? this.colors.length : this._color_index;
        return this.colors[offset - 1];
    },
    _label: function (value) {
        var sep = this.klass.THOUSAND_SEPARATOR,
            label =
                this._spread % this.marker_count == 0 || this.y_axis_increment !== null
                    ? String(Math.round(value))
                    : String(Math.floor(value * this._significant_digits) / this._significant_digits);
        var parts = label.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
        return parts.join('.');
    },
    _calculate_caps_height: function (font_size) {
        return this._d.caps_height(font_size);
    },
    _calculate_width: function (font_size, text) {
        return this._d.text_width(font_size, text);
    },
});
Bluff.Area = new JS.Class(Bluff.Base, {
    draw: function () {
        this.callSuper();
        if (!this._has_data) return;
        this._x_increment = this._graph_width / (this._column_count - 1);
        this._d.stroke = 'transparent';
        Bluff.each(
            this._norm_data,
            function (data_row) {
                var poly_points = [],
                    poly_overline = [],
                    prev_x = 0,
                    prev_y = 0;
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, index) {
                        var new_x = this._graph_left + this._x_increment * index;
                        var new_y = this._graph_top + (this._graph_height - data_point * this._graph_height);
                        if (prev_x > 0 && prev_y > 0) {
                            poly_points.push(new_x);
                            poly_points.push(new_y);
                            var circle_radius =
                                this.dot_radius ||
                                this._clip_value_if_greater_than(
                                    this._columns / (this._norm_data[0][this.klass.DATA_VALUES_INDEX].length * 2),
                                    7
                                );
                            poly_overline.push(prev_x);
                            poly_overline.push(prev_y);
                            poly_overline.push(new_x);
                            poly_overline.push(new_y);
                        } else {
                            poly_points.push(this._graph_left);
                            poly_points.push(this._graph_bottom - 1);
                            poly_points.push(new_x);
                            poly_points.push(new_y);
                            poly_overline.push(this._graph_left);
                            poly_overline.push(this._graph_bottom - 1);
                            poly_overline.push(new_x);
                            poly_overline.push(new_y);
                        }
                        if (this.y_axis_skip == null || index % this.y_axis_skip === 0) this._draw_label(new_x, index);
                        this._draw_tooltip(
                            new_x - this.dot_radius,
                            new_y - this.dot_radius,
                            2 * this.dot_radius,
                            2 * this.dot_radius,
                            eval('this.tooltipTxt' + data_row[this.klass.DATA_LABEL_INDEX])[index],
                            '#f00',
                            ''
                        );
                        prev_x = new_x;
                        prev_y = new_y;
                    },
                    this
                );
                poly_points.push(this._graph_right);
                poly_points.push(this._graph_bottom - 1);
                poly_points.push(this._graph_left);
                poly_points.push(this._graph_bottom - 1);
                this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                this._d.polyline(poly_points);
                var arLen = poly_overline.length;
                for (var i = 0; i < arLen; i = i + 4) {
                    var a1, a2, a3, a4;
                    a1 = poly_overline[i];
                    a2 = poly_overline[i + 1];
                    a3 = poly_overline[i + 2];
                    a4 = poly_overline[i + 3];
                    this._d.stroke = this.line_color;
                    if (this.line_width) this._d.stroke_width = this.line_width;
                    else this._d.stroke_width = 2;
                    if (i != 0) this._d.line(a1, a2, a3, a4);
                    if (!this.hide_dots) {
                        this._d.fill = this.line_color;
                        this._d.circle(a3, a4, a3 - this.dot_radius, a4);
                    }
                }
            },
            this
        );
    },
});
Bluff.BarConversion = new JS.Class({
    mode: null,
    zero: null,
    graph_top: null,
    graph_height: null,
    minimum_value: null,
    spread: null,
    getLeftYRightYscaled: function (data_point, result) {
        var val;
        switch (this.mode) {
            case 1:
                result[0] = this.graph_top + this.graph_height * (1 - data_point) + 1;
                result[1] = this.graph_top + this.graph_height - 1;
                break;
            case 2:
                result[0] = this.graph_top + 1;
                result[1] = this.graph_top + this.graph_height * (1 - data_point) - 1;
                break;
            case 3:
                val = data_point - this.minimum_value / this.spread;
                if (data_point >= this.zero) {
                    result[0] = this.graph_top + this.graph_height * (1 - (val - this.zero)) + 1;
                    result[1] = this.graph_top + this.graph_height * (1 - this.zero) - 1;
                } else {
                    result[0] = this.graph_top + this.graph_height * (1 - (val - this.zero)) + 1;
                    result[1] = this.graph_top + this.graph_height * (1 - this.zero) - 1;
                }
                break;
            default:
                result[0] = 0;
                result[1] = 0;
        }
    },
});
Bluff.Bar = new JS.Class(Bluff.Base, {
    bar_spacing: 0.9,
    draw: function () {
        this.center_labels_over_point = Bluff.keys(this.labels).length > this._column_count;
        this.callSuper();
        if (!this._has_data) return;
        this._draw_bars();
    },
    _draw_bars: function () {
        this._bar_width = this._graph_width / (this._column_count * this._data.length);
        var padding = (this._bar_width * (1 - this.bar_spacing)) / 2;
        this._d.stroke_opacity = 0;
        var conversion = new Bluff.BarConversion();
        conversion.graph_height = this._graph_height;
        conversion.graph_top = this._graph_top;
        if (this.minimum_value >= 0) conversion.mode = 1;
        else if (this.maximum_value <= 0) conversion.mode = 2;
        else {
            conversion.mode = 3;
            conversion.spread = this._spread;
            conversion.minimum_value = this.minimum_value;
            conversion.zero = -this.minimum_value / this._spread;
        }
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                var raw_data = this._data[row_index][this.klass.DATA_VALUES_INDEX];
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, point_index) {
                        var left_x =
                            this._graph_left +
                            this._bar_width * (row_index + point_index + (this._data.length - 1) * point_index) +
                            padding;
                        var right_x = left_x + this._bar_width * this.bar_spacing;
                        var conv = [];
                        conversion.getLeftYRightYscaled(data_point, conv);
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.rectangle(left_x, conv[0], right_x, conv[1]);
                        this._draw_tooltip(
                            left_x,
                            conv[0],
                            right_x - left_x,
                            conv[1] - conv[0],
                            data_row[this.klass.DATA_LABEL_INDEX],
                            data_row[this.klass.DATA_COLOR_INDEX],
                            raw_data[point_index]
                        );
                        var label_center =
                            this._graph_left +
                            this._data.length * this._bar_width * point_index +
                            (this._data.length * this._bar_width) / 2;
                        this._draw_label(
                            label_center - (this.center_labels_over_point ? this._bar_width / 2 : 0),
                            point_index
                        );
                    },
                    this
                );
            },
            this
        );
        if (this.center_labels_over_point) this._draw_label(this._graph_right, this._column_count);
    },
});
Bluff.Line = new JS.Class(Bluff.Base, {
    baseline_value: null,
    baseline_color: null,
    line_width: null,
    dot_radius: null,
    hide_dots: null,
    hide_lines: null,
    initialize: function (renderer) {
        if (arguments.length > 3) throw 'Wrong number of arguments';
        if (arguments.length === 1 || (typeof arguments[1] !== 'number' && typeof arguments[1] !== 'string'))
            this.callSuper(renderer, null);
        else this.callSuper();
        this.hide_dots = this.hide_lines = false;
        this.baseline_color = 'red';
        this.baseline_value = null;
    },
    draw: function () {
        this.callSuper();
        if (!this._has_data) return;
        this.x_increment = this._column_count > 1 ? this._graph_width / (this._column_count - 1) : this._graph_width;
        var level;
        if (this._norm_baseline !== undefined) {
            level = this._graph_top + (this._graph_height - this._norm_baseline * this._graph_height);
            this._d.push();
            this._d.stroke = this.baseline_color;
            this._d.fill_opacity = 0;
            this._d.stroke_width = 3;
            this._d.line(this._graph_left, level, this._graph_left + this._graph_width, level);
            this._d.pop();
        }
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                var prev_x = null,
                    prev_y = null;
                var raw_data = this._data[row_index][this.klass.DATA_VALUES_INDEX];
                this._one_point = this._contains_one_point_only(data_row);
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, index) {
                        var new_x = this._graph_left + this.x_increment * index;
                        if (typeof data_point !== 'number') return;
                        this._draw_label(new_x, index);
                        var new_y = this._graph_top + (this._graph_height - data_point * this._graph_height);
                        this._d.stroke = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.stroke_opacity = 1;
                        this._d.stroke_width =
                            this.line_width ||
                            this._clip_value_if_greater_than(
                                this._columns / (this._norm_data[0][this.klass.DATA_VALUES_INDEX].length * 6),
                                3
                            );
                        var circle_radius =
                            this.dot_radius ||
                            this._clip_value_if_greater_than(
                                this._columns / (this._norm_data[0][this.klass.DATA_VALUES_INDEX].length * 2),
                                7
                            );
                        if (!this.hide_lines && prev_x !== null && prev_y !== null)
                            this._d.line(prev_x, prev_y, new_x, new_y);
                        else if (this._one_point) this._d.circle(new_x, new_y, new_x - circle_radius, new_y);
                        if (!this.hide_dots) this._d.circle(new_x, new_y, new_x - circle_radius, new_y);
                        this._draw_tooltip(
                            new_x - this.dot_radius,
                            new_y - this.dot_radius,
                            2 * this.dot_radius,
                            2 * this.dot_radius,
                            eval('this.tooltipTxt' + data_row[this.klass.DATA_LABEL_INDEX])[index],
                            '#f00',
                            ''
                        );
                        prev_x = new_x;
                        prev_y = new_y;
                    },
                    this
                );
            },
            this
        );
    },
    _normalize: function () {
        this.maximum_value = Math.max(this.maximum_value, this.baseline_value);
        this.callSuper();
        if (this.baseline_value !== null) this._norm_baseline = this.baseline_value / this.maximum_value;
    },
    _contains_one_point_only: function (data_row) {
        var count = 0;
        Bluff.each(data_row[this.klass.DATA_VALUES_INDEX], function (data_point) {
            if (data_point !== undefined) count += 1;
        });
        return count === 1;
    },
});
Bluff.Dot = new JS.Class(Bluff.Base, {
    draw: function () {
        this.has_left_labels = true;
        this.callSuper();
        if (!this._has_data) return;
        var spacing_factor = 1;
        this._items_width = this._graph_height / this._column_count;
        this._item_width = (this._items_width * spacing_factor) / this._norm_data.length;
        this._d.stroke_opacity = 0;
        var height = Bluff.array_new(this._column_count, 0),
            length = Bluff.array_new(this._column_count, this._graph_left),
            padding = (this._items_width * (1 - spacing_factor)) / 2;
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, point_index) {
                        var x_pos =
                            this._graph_left + data_point * this._graph_width - Math.round(this._item_width / 6);
                        var y_pos =
                            this._graph_top +
                            this._items_width * point_index +
                            padding +
                            Math.round(this._item_width / 2);
                        if (row_index === 0) {
                            this._d.stroke = this.marker_color;
                            this._d.stroke_width = 1;
                            this._d.opacity = 0.1;
                            this._d.line(this._graph_left, y_pos, this._graph_left + this._graph_width, y_pos);
                        }
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.stroke = 'transparent';
                        this._d.circle(x_pos, y_pos, x_pos + Math.round(this._item_width / 3), y_pos);
                        var label_center =
                            this._graph_top + (this._items_width * point_index + this._items_width / 2) + padding;
                        this._draw_label(label_center, point_index);
                    },
                    this
                );
            },
            this
        );
    },
    _draw_line_markers: function () {
        if (this.hide_line_markers) return;
        this._d.stroke_antialias = false;
        this._d.stroke_width = 1;
        var number_of_lines = 5;
        var increment = this._significant(this.maximum_value / number_of_lines);
        for (var index = 0; index <= number_of_lines; index++) {
            var line_diff = (this._graph_right - this._graph_left) / number_of_lines,
                x = this._graph_right - line_diff * index - 1,
                diff = index - number_of_lines,
                marker_label = Math.abs(diff) * increment;
            this._d.stroke = this.marker_color;
            this._d.line(x, this._graph_bottom, x, this._graph_bottom + 0.5 * this.klass.LABEL_MARGIN);
            if (!this.hide_line_numbers) {
                this._d.fill = this.font_color;
                if (this.font) this._d.font = this.font;
                this._d.stroke = 'transparent';
                this._d.pointsize = this._scale_fontsize(this.marker_font_size);
                this._d.gravity = 'center';
                this._d.annotate_scaled(
                    0,
                    0,
                    x,
                    this._graph_bottom + this.klass.LABEL_MARGIN * 2,
                    marker_label,
                    this._scale
                );
            }
            this._d.stroke_antialias = true;
        }
    },
    _draw_label: function (y_offset, index) {
        if (this.labels[index] && !this._labels_seen[index]) {
            this._d.fill = this.font_color;
            if (this.font) this._d.font = this.font;
            this._d.stroke = 'transparent';
            this._d.font_weight = 'normal';
            this._d.pointsize = this._scale_fontsize(this.marker_font_size);
            this._d.gravity = 'east';
            this._d.annotate_scaled(
                1,
                1,
                this._graph_left - this.klass.LABEL_MARGIN * 2,
                y_offset,
                this.labels[index],
                this._scale
            );
            this._labels_seen[index] = true;
        }
    },
});
Bluff.Net = new JS.Class(Bluff.Base, {
    hide_dots: null,
    line_width: null,
    dot_radius: null,
    initialize: function () {
        this.callSuper();
        this.hide_dots = false;
        this.hide_line_numbers = true;
    },
    draw: function () {
        this.callSuper();
        if (!this._has_data) return;
        this._radius = this._graph_height / 2;
        this._center_x = this._graph_left + this._graph_width / 2;
        this._center_y = this._graph_top + this._graph_height / 2 - 10;
        this._x_increment = this._graph_width / (this._column_count - 1);
        var circle_radius =
            this.dot_radius ||
            this._clip_value_if_greater_than(
                this._columns / (this._norm_data[0][this.klass.DATA_VALUES_INDEX].length * 2.5),
                7
            );
        this._d.stroke_opacity = 1;
        this._d.stroke_width =
            this.line_width ||
            this._clip_value_if_greater_than(
                this._columns / (this._norm_data[0][this.klass.DATA_VALUES_INDEX].length * 4),
                3
            );
        var level;
        if (this._norm_baseline !== undefined) {
            level = this._graph_top + (this._graph_height - this._norm_baseline * this._graph_height);
            this._d.push();
            this._d.stroke_color = this.baseline_color;
            this._d.fill_opacity = 0;
            this._d.stroke_width = 5;
            this._d.line(this._graph_left, level, this._graph_left + this._graph_width, level);
            this._d.pop();
        }
        Bluff.each(
            this._norm_data,
            function (data_row) {
                var prev_x = null,
                    prev_y = null;
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, index) {
                        if (data_point === undefined) return;
                        var rad_pos = (index * Math.PI * 2) / this._column_count,
                            point_distance = data_point * this._radius,
                            start_x = this._center_x + Math.sin(rad_pos) * point_distance,
                            start_y = this._center_y - Math.cos(rad_pos) * point_distance,
                            next_index = index + 1 < data_row[this.klass.DATA_VALUES_INDEX].length ? index + 1 : 0,
                            next_rad_pos = (next_index * Math.PI * 2) / this._column_count,
                            next_point_distance = data_row[this.klass.DATA_VALUES_INDEX][next_index] * this._radius,
                            end_x = this._center_x + Math.sin(next_rad_pos) * next_point_distance,
                            end_y = this._center_y - Math.cos(next_rad_pos) * next_point_distance;
                        this._d.stroke = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.line(start_x, start_y, end_x, end_y);
                        if (!this.hide_dots) this._d.circle(start_x, start_y, start_x - circle_radius, start_y);
                    },
                    this
                );
            },
            this
        );
    },
    _draw_line_markers: function () {
        if (this.hide_line_markers) return;
        this._radius = this._graph_height / 2;
        this._center_x = this._graph_left + this._graph_width / 2;
        this._center_y = this._graph_top + this._graph_height / 2 - 10;
        var rad_pos, marker_label;
        for (var index = 0, n = this._column_count; index < n; index++) {
            rad_pos = (index * Math.PI * 2) / this._column_count;
            this._d.stroke = this.marker_color;
            this._d.stroke_width = 1;
            this._d.line(
                this._center_x,
                this._center_y,
                this._center_x + Math.sin(rad_pos) * this._radius,
                this._center_y - Math.cos(rad_pos) * this._radius
            );
            marker_label = labels[index] ? labels[index] : '000';
            this._draw_label(
                this._center_x,
                this._center_y,
                (rad_pos * 360) / (2 * Math.PI),
                this._radius,
                marker_label
            );
        }
    },
    _draw_label: function (center_x, center_y, angle, radius, amount) {
        var r_offset = 1.1,
            x_offset = center_x,
            y_offset = center_y,
            rad_pos = (angle * Math.PI) / 180,
            x = x_offset + radius * r_offset * Math.sin(rad_pos),
            y = y_offset - radius * r_offset * Math.cos(rad_pos);
        this._d.fill = this.marker_color;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this._scale_fontsize(20);
        this._d.stroke = 'transparent';
        this._d.font_weight = 'bold';
        this._d.gravity = 'center';
        this._d.annotate_scaled(0, 0, x, y, amount, this._scale);
    },
});
Bluff.Pie = new JS.Class(Bluff.Base, {
    extend: {
        TEXT_OFFSET_PERCENTAGE: 0.08,
    },
    zero_degreee: null,
    hide_labels_less_than: null,
    initialize_ivars: function () {
        this.callSuper();
        this.zero_degree = 0;
        this.hide_labels_less_than = 0;
    },
    draw: function () {
        this.hide_line_markers = true;
        this.callSuper();
        if (!this._has_data) return;
        var diameter = this._graph_height,
            radius = (Math.min(this._graph_width, this._graph_height) / 2) * 0.8,
            top_x = this._graph_left + (this._graph_width - diameter) / 2,
            center_x = this._graph_left + this._graph_width / 2,
            center_y = this._graph_top + this._graph_height / 2 - 10,
            total_sum = this._sums_for_pie(),
            prev_degrees = this.zero_degree,
            index = this.klass.DATA_VALUES_INDEX;
        if (this.sort)
            this._data.sort(function (a, b) {
                return a[index][0] - b[index][0];
            });
        Bluff.each(
            this._data,
            function (data_row, i) {
                if (data_row[this.klass.DATA_VALUES_INDEX][0] > 0) {
                    this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                    var current_degrees = (data_row[this.klass.DATA_VALUES_INDEX][0] / total_sum) * 360;
                    this._d.circle(
                        center_x,
                        center_y,
                        center_x + radius,
                        center_y,
                        prev_degrees,
                        prev_degrees + current_degrees + 0.5
                    );
                    var half_angle = prev_degrees + (prev_degrees + current_degrees - prev_degrees) / 2,
                        label_val = Math.round((data_row[this.klass.DATA_VALUES_INDEX][0] / total_sum) * 100),
                        label_string;
                    if (label_val >= this.hide_labels_less_than) {
                        label_string = this._label(data_row[this.klass.DATA_VALUES_INDEX][0]);
                        this._draw_label(
                            center_x,
                            center_y,
                            half_angle,
                            radius + radius * this.klass.TEXT_OFFSET_PERCENTAGE,
                            label_string
                        );
                    }
                    prev_degrees += current_degrees;
                }
            },
            this
        );
    },
    _draw_label: function (center_x, center_y, angle, radius, amount) {
        var r_offset = 20,
            x_offset = center_x,
            y_offset = center_y,
            radius_offset = radius + r_offset,
            ellipse_factor = radius_offset * 0.15,
            x = x_offset + (radius_offset + ellipse_factor) * Math.cos((angle * Math.PI) / 180),
            y = y_offset + radius_offset * Math.sin((angle * Math.PI) / 180);
        this._d.fill = this.font_color;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this._scale_fontsize(this.marker_font_size);
        this._d.font_weight = 'bold';
        this._d.gravity = 'center';
        this._d.annotate_scaled(0, 0, x, y, amount, this._scale);
    },
    _sums_for_pie: function () {
        var total_sum = 0;
        Bluff.each(
            this._data,
            function (data_row) {
                total_sum += data_row[this.klass.DATA_VALUES_INDEX][0];
            },
            this
        );
        return total_sum;
    },
});
Bluff.SideBar = new JS.Class(Bluff.Base, {
    bar_spacing: 0.9,
    draw: function () {
        this.has_left_labels = true;
        this.callSuper();
        if (!this._has_data) return;
        this._bars_width = this._graph_height / this._column_count;
        this._bar_width = (this._bars_width * this.bar_spacing) / this._norm_data.length;
        this._d.stroke_opacity = 0;
        var height = Bluff.array_new(this._column_count, 0),
            length = Bluff.array_new(this._column_count, this._graph_left),
            padding = (this._bars_width * (1 - this.bar_spacing)) / 2;
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                var raw_data = this._data[row_index][this.klass.DATA_VALUES_INDEX];
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, point_index) {
                        var temp1 =
                                this._graph_left +
                                (this._graph_width - data_point * this._graph_width - height[point_index]),
                            temp2 = this._graph_left + this._graph_width - height[point_index],
                            difference = temp2 - temp1,
                            left_x = length[point_index] - 1,
                            left_y =
                                this._graph_top +
                                this._bars_width * point_index +
                                this._bar_width * row_index +
                                padding,
                            right_x = left_x + difference,
                            right_y = left_y + this._bar_width;
                        height[point_index] += data_point * this._graph_width;
                        this._d.stroke = 'transparent';
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.rectangle(left_x, left_y, right_x, right_y);
                        this._draw_tooltip(
                            left_x,
                            left_y,
                            right_x - left_x,
                            right_y - left_y,
                            data_row[this.klass.DATA_LABEL_INDEX],
                            data_row[this.klass.DATA_COLOR_INDEX],
                            raw_data[point_index]
                        );
                        var label_center = this._graph_top + (this._bars_width * point_index + this._bars_width / 2);
                        this._draw_label(label_center, point_index);
                    },
                    this
                );
            },
            this
        );
    },
    _draw_line_markers: function () {
        if (this.hide_line_markers) return;
        this._d.stroke_antialias = false;
        this._d.stroke_width = 1;
        var number_of_lines = 5;
        var increment = this._significant(this.maximum_value / number_of_lines),
            line_diff,
            x,
            diff,
            marker_label;
        for (var index = 0; index <= number_of_lines; index++) {
            line_diff = (this._graph_right - this._graph_left) / number_of_lines;
            x = this._graph_right - line_diff * index - 1;
            diff = index - number_of_lines;
            marker_label = Math.abs(diff) * increment;
            this._d.stroke = this.marker_color;
            this._d.line(x, this._graph_bottom, x, this._graph_top);
            if (!this.hide_line_numbers) {
                this._d.fill = this.font_color;
                if (this.font) this._d.font = this.font;
                this._d.stroke = 'transparent';
                this._d.pointsize = this._scale_fontsize(this.marker_font_size);
                this._d.gravity = 'center';
                this._d.annotate_scaled(
                    0,
                    0,
                    x,
                    this._graph_bottom + this.klass.LABEL_MARGIN * 2,
                    marker_label,
                    this._scale
                );
            }
        }
    },
    _draw_label: function (y_offset, index) {
        if (this.labels[index] && !this._labels_seen[index]) {
            this._d.fill = this.font_color;
            if (this.font) this._d.font = this.font;
            this._d.stroke = 'transparent';
            this._d.font_weight = 'normal';
            this._d.pointsize = this._scale_fontsize(this.marker_font_size);
            this._d.gravity = 'east';
            this._d.annotate_scaled(
                1,
                1,
                this._graph_left - this.klass.LABEL_MARGIN * 2,
                y_offset,
                this.labels[index],
                this._scale
            );
            this._labels_seen[index] = true;
        }
    },
});
Bluff.Spider = new JS.Class(Bluff.Base, {
    hide_text: null,
    hide_axes: null,
    transparent_background: null,
    initialize: function (renderer, max_value, target_width) {
        this.callSuper(renderer, target_width);
        this._max_value = max_value;
        this.hide_legend = true;
    },
    draw: function () {
        this.hide_line_markers = true;
        this.callSuper();
        if (!this._has_data) return;
        var diameter = this._graph_height,
            radius = this._graph_height / 2,
            top_x = this._graph_left + (this._graph_width - diameter) / 2,
            center_x = this._graph_left + this._graph_width / 2,
            center_y = this._graph_top + this._graph_height / 2 - 25;
        this._unit_length = radius / this._max_value;
        var total_sum = this._sums_for_spider(),
            prev_degrees = 0,
            additive_angle = (2 * Math.PI) / this._data.length,
            current_angle = 0;
        if (!this.hide_axes) this._draw_axes(center_x, center_y, radius, additive_angle);
        this._draw_polygon(center_x, center_y, additive_angle);
    },
    _normalize_points: function (value) {
        return value * this._unit_length;
    },
    _draw_label: function (center_x, center_y, angle, radius, amount) {
        var r_offset = 50,
            x_offset = center_x,
            y_offset = center_y + 0,
            x = x_offset + (radius + r_offset) * Math.cos(angle),
            y = y_offset + (radius + r_offset) * Math.sin(angle);
        this._d.fill = this.marker_color;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this._scale_fontsize(this.legend_font_size);
        this._d.stroke = 'transparent';
        this._d.font_weight = 'bold';
        this._d.gravity = 'center';
        this._d.annotate_scaled(0, 0, x, y, amount, this._scale);
    },
    _draw_axes: function (center_x, center_y, radius, additive_angle, line_color) {
        if (this.hide_axes) return;
        var current_angle = 0;
        Bluff.each(
            this._data,
            function (data_row) {
                this._d.stroke = line_color || data_row[this.klass.DATA_COLOR_INDEX];
                this._d.stroke_width = 5;
                var x_offset = radius * Math.cos(current_angle);
                var y_offset = radius * Math.sin(current_angle);
                this._d.line(center_x, center_y, center_x + x_offset, center_y + y_offset);
                if (!this.hide_text)
                    this._draw_label(center_x, center_y, current_angle, radius, data_row[this.klass.DATA_LABEL_INDEX]);
                current_angle += additive_angle;
            },
            this
        );
    },
    _draw_polygon: function (center_x, center_y, additive_angle, color) {
        var points = [],
            current_angle = 0;
        Bluff.each(
            this._data,
            function (data_row) {
                points.push(
                    center_x +
                        this._normalize_points(data_row[this.klass.DATA_VALUES_INDEX][0]) * Math.cos(current_angle)
                );
                points.push(
                    center_y +
                        this._normalize_points(data_row[this.klass.DATA_VALUES_INDEX][0]) * Math.sin(current_angle)
                );
                current_angle += additive_angle;
            },
            this
        );
        this._d.stroke_width = 1;
        this._d.stroke = color || this.marker_color;
        this._d.fill = color || this.marker_color;
        this._d.fill_opacity = 0.4;
        this._d.polyline(points);
    },
    _sums_for_spider: function () {
        var sum = 0;
        Bluff.each(
            this._data,
            function (data_row) {
                sum += data_row[this.klass.DATA_VALUES_INDEX][0];
            },
            this
        );
        return sum;
    },
});
Bluff.Base.StackedMixin = new JS.Module({
    _get_maximum_by_stack: function () {
        var max_hash = {};
        Bluff.each(
            this._data,
            function (data_set) {
                Bluff.each(
                    data_set[this.klass.DATA_VALUES_INDEX],
                    function (data_point, i) {
                        if (!max_hash[i]) max_hash[i] = 0;
                        max_hash[i] += data_point;
                    },
                    this
                );
            },
            this
        );
        for (var key in max_hash) if (max_hash[key] > this.maximum_value) this.maximum_value = max_hash[key];
        this.minimum_value = 0;
    },
});
Bluff.StackedArea = new JS.Class(Bluff.Base, {
    include: Bluff.Base.StackedMixin,
    last_series_goes_on_bottom: null,
    draw: function () {
        this._get_maximum_by_stack();
        this.callSuper();
        if (!this._has_data) return;
        this._x_increment = this._graph_width / (this._column_count - 1);
        this._d.stroke = 'transparent';
        var height = Bluff.array_new(this._column_count, 0);
        var data_points = null;
        var iterator = this.last_series_goes_on_bottom ? 'reverse_each' : 'each';
        Bluff[iterator](
            this._norm_data,
            function (data_row) {
                var prev_data_points = data_points;
                data_points = [];
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, index) {
                        var new_x = this._graph_left + this._x_increment * index;
                        var new_y =
                            this._graph_top + (this._graph_height - data_point * this._graph_height - height[index]);
                        height[index] += data_point * this._graph_height;
                        data_points.push(new_x);
                        data_points.push(new_y);
                        this._draw_label(new_x, index);
                    },
                    this
                );
                var poly_points, i, n;
                if (prev_data_points) {
                    poly_points = Bluff.array(data_points);
                    for (i = prev_data_points.length / 2 - 1; i >= 0; i--) {
                        poly_points.push(prev_data_points[2 * i]);
                        poly_points.push(prev_data_points[2 * i + 1]);
                    }
                    poly_points.push(data_points[0]);
                    poly_points.push(data_points[1]);
                } else {
                    poly_points = Bluff.array(data_points);
                    poly_points.push(this._graph_right);
                    poly_points.push(this._graph_bottom - 1);
                    poly_points.push(this._graph_left);
                    poly_points.push(this._graph_bottom - 1);
                    poly_points.push(data_points[0]);
                    poly_points.push(data_points[1]);
                }
                this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                this._d.polyline(poly_points);
            },
            this
        );
    },
});
Bluff.StackedBar = new JS.Class(Bluff.Base, {
    include: Bluff.Base.StackedMixin,
    bar_spacing: 0.9,
    draw: function () {
        this._get_maximum_by_stack();
        this.callSuper();
        if (!this._has_data) return;
        this._bar_width = this._graph_width / this._column_count;
        var padding = (this._bar_width * (1 - this.bar_spacing)) / 2;
        this._d.stroke_opacity = 0;
        var height = Bluff.array_new(this._column_count, 0);
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                var raw_data = this._data[row_index][this.klass.DATA_VALUES_INDEX];
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, point_index) {
                        var label_center =
                            this._graph_left + this._bar_width * point_index + (this._bar_width * this.bar_spacing) / 2;
                        this._draw_label(label_center, point_index);
                        if (data_point == 0) return;
                        var left_x = this._graph_left + this._bar_width * point_index + padding;
                        var left_y =
                            this._graph_top +
                            (this._graph_height - data_point * this._graph_height - height[point_index]) +
                            1;
                        var right_x = left_x + this._bar_width * this.bar_spacing;
                        var right_y = this._graph_top + this._graph_height - height[point_index] - 1;
                        height[point_index] += data_point * this._graph_height;
                        this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                        this._d.rectangle(left_x, left_y, right_x, right_y);
                        this._draw_tooltip(
                            left_x,
                            left_y,
                            right_x - left_x,
                            right_y - left_y,
                            data_row[this.klass.DATA_LABEL_INDEX],
                            data_row[this.klass.DATA_COLOR_INDEX],
                            raw_data[point_index]
                        );
                    },
                    this
                );
            },
            this
        );
    },
});
Bluff.AccumulatorBar = new JS.Class(Bluff.StackedBar, {
    draw: function () {
        if (this._data.length !== 1) throw 'Incorrect number of datasets';
        var accumulator_array = [],
            index = 0,
            increment_array = [];
        Bluff.each(
            this._data[0][this.klass.DATA_VALUES_INDEX],
            function (value) {
                var max = -Infinity;
                Bluff.each(increment_array, function (x) {
                    max = Math.max(max, x);
                });
                increment_array.push(index > 0 ? value + max : value);
                accumulator_array.push(increment_array[index] - value);
                index += 1;
            },
            this
        );
        this.data('Accumulator', accumulator_array);
        this.callSuper();
    },
});
Bluff.SideStackedBar = new JS.Class(Bluff.SideBar, {
    include: Bluff.Base.StackedMixin,
    bar_spacing: 0.9,
    draw: function () {
        this.has_left_labels = true;
        this._get_maximum_by_stack();
        this.callSuper();
        if (!this._has_data) return;
        this._bar_width = this._graph_height / this._column_count;
        var height = Bluff.array_new(this._column_count, 0),
            length = Bluff.array_new(this._column_count, this._graph_left),
            padding = (this._bar_width * (1 - this.bar_spacing)) / 2;
        Bluff.each(
            this._norm_data,
            function (data_row, row_index) {
                this._d.fill = data_row[this.klass.DATA_COLOR_INDEX];
                var raw_data = this._data[row_index][this.klass.DATA_VALUES_INDEX];
                Bluff.each(
                    data_row[this.klass.DATA_VALUES_INDEX],
                    function (data_point, point_index) {
                        var temp1 =
                            this._graph_left +
                            (this._graph_width - data_point * this._graph_width - height[point_index]) +
                            1;
                        var temp2 = this._graph_left + this._graph_width - height[point_index] - 1;
                        var difference = temp2 - temp1;
                        var left_x = length[point_index],
                            left_y = this._graph_top + this._bar_width * point_index + padding,
                            right_x = left_x + difference,
                            right_y = left_y + this._bar_width * this.bar_spacing;
                        length[point_index] += difference;
                        height[point_index] += data_point * this._graph_width - 2;
                        this._d.rectangle(left_x, left_y, right_x, right_y);
                        this._draw_tooltip(
                            left_x,
                            left_y,
                            right_x - left_x,
                            right_y - left_y,
                            data_row[this.klass.DATA_LABEL_INDEX],
                            data_row[this.klass.DATA_COLOR_INDEX],
                            raw_data[point_index]
                        );
                        var label_center =
                            this._graph_top + this._bar_width * point_index + (this._bar_width * this.bar_spacing) / 2;
                        this._draw_label(label_center, point_index);
                    },
                    this
                );
            },
            this
        );
    },
    _larger_than_max: function (data_point, index) {
        index = index || 0;
        return this._max(data_point, index) > this.maximum_value;
    },
    _max: function (data_point, index) {
        var sum = 0;
        Bluff.each(
            this._data,
            function (item) {
                sum += item[this.klass.DATA_VALUES_INDEX][index];
            },
            this
        );
        return sum;
    },
});
Bluff.Mini.Legend = new JS.Module({
    hide_mini_legend: false,
    _expand_canvas_for_vertical_legend: function () {
        if (this.hide_mini_legend) return;
        this._original_rows = this._raw_rows;
        this._rows +=
            this._data.length * this._calculate_caps_height(this._scale_fontsize(this.legend_font_size)) * 1.7;
        this._render_background();
    },
    _draw_vertical_legend: function () {
        if (this.hide_mini_legend) return;
        this._legend_labels = Bluff.map(
            this._data,
            function (item) {
                return item[this.klass.DATA_LABEL_INDEX];
            },
            this
        );
        var legend_square_width = 40,
            legend_square_margin = 10,
            legend_left_margin = 100,
            legend_top_margin = 40;
        if (this.font) this._d.font = this.font;
        this._d.pointsize = this.legend_font_size;
        var current_x_offset = legend_left_margin,
            current_y_offset = this._original_rows + legend_top_margin;
        this._debug(function () {
            this._d.line(0, current_y_offset, this._raw_columns, current_y_offset);
        });
        Bluff.each(
            this._legend_labels,
            function (legend_label, index) {
                this._d.fill = this.font_color;
                if (this.font) this._d.font = this.font;
                this._d.pointsize = this._scale_fontsize(this.legend_font_size);
                this._d.stroke = 'transparent';
                this._d.font_weight = 'normal';
                this._d.gravity = 'west';
                this._d.annotate_scaled(
                    this._raw_columns,
                    1,
                    current_x_offset + legend_square_width * 1.7,
                    current_y_offset,
                    this._truncate_legend_label(legend_label),
                    this._scale
                );
                this._d.stroke = 'transparent';
                this._d.fill = this._data[index][this.klass.DATA_COLOR_INDEX];
                this._d.rectangle(
                    current_x_offset,
                    current_y_offset - legend_square_width / 2,
                    current_x_offset + legend_square_width,
                    current_y_offset + legend_square_width / 2
                );
                current_y_offset += this._calculate_caps_height(this.legend_font_size) * 1.7;
            },
            this
        );
        this._color_index = 0;
    },
    _truncate_legend_label: function (label) {
        var truncated_label = String(label);
        while (
            this._calculate_width(this._scale_fontsize(this.legend_font_size), truncated_label) >
                this._columns - this.legend_left_margin - this.right_margin &&
            truncated_label.length > 1
        )
            truncated_label = truncated_label.substr(0, truncated_label.length - 1);
        return truncated_label + (truncated_label.length < String(label).length ? '...' : '');
    },
});
Bluff.Mini.Bar = new JS.Class(Bluff.Bar, {
    include: Bluff.Mini.Legend,
    initialize_ivars: function () {
        this.callSuper();
        this.hide_legend = true;
        this.hide_title = true;
        this.hide_line_numbers = true;
        this.marker_font_size = 50;
        this.minimum_value = 0;
        this.maximum_value = 0;
        this.legend_font_size = 60;
    },
    draw: function () {
        this._expand_canvas_for_vertical_legend();
        this.callSuper();
        this._draw_vertical_legend();
    },
});
Bluff.Mini.Pie = new JS.Class(Bluff.Pie, {
    include: Bluff.Mini.Legend,
    initialize_ivars: function () {
        this.callSuper();
        this.hide_legend = true;
        this.hide_title = true;
        this.hide_line_numbers = true;
        this.marker_font_size = 60;
        this.legend_font_size = 60;
    },
    draw: function () {
        this._expand_canvas_for_vertical_legend();
        this.callSuper();
        this._draw_vertical_legend();
    },
});
Bluff.Mini.SideBar = new JS.Class(Bluff.SideBar, {
    include: Bluff.Mini.Legend,
    initialize_ivars: function () {
        this.callSuper();
        this.hide_legend = true;
        this.hide_title = true;
        this.hide_line_numbers = true;
        this.marker_font_size = 50;
        this.legend_font_size = 50;
    },
    draw: function () {
        this._expand_canvas_for_vertical_legend();
        this.callSuper();
        this._draw_vertical_legend();
    },
});
Bluff.Renderer = new JS.Class({
    extend: {
        WRAPPER_CLASS: 'bluff-wrapper',
        TEXT_CLASS: 'bluff-text',
        TARGET_CLASS: 'bluff-tooltip-target',
    },
    font: 'Arial, Helvetica, Verdana, sans-serif',
    gravity: 'north',
    initialize: function (canvasId) {
        this._canvas = document.getElementById(canvasId);
        this._ctx = this._canvas.getContext('2d');
    },
    scale: function (sx, sy) {
        this._sx = sx;
        this._sy = sy || sx;
    },
    caps_height: function (font_size) {
        var X = this._sized_text(font_size, 'X'),
            height = this._element_size(X).height;
        this._remove_node(X);
        return height;
    },
    text_width: function (font_size, text) {
        var element = this._sized_text(font_size, text);
        var width = this._element_size(element).width;
        this._remove_node(element);
        return width;
    },
    get_type_metrics: function (text) {
        var node = this._sized_text(this.pointsize, text);
        document.body.appendChild(node);
        var size = this._element_size(node);
        this._remove_node(node);
        return size;
    },
    clear: function (width, height) {
        this._canvas.width = width;
        this._canvas.height = height;
        this._ctx.clearRect(0, 0, width, height);
        var wrapper = this._text_container(),
            children = wrapper.childNodes,
            i = children.length;
        while (i--) if (children[i].tagName.toLowerCase() !== 'canvas') this._remove_node(children[i]);
    },
    push: function () {
        this._ctx.save();
    },
    pop: function () {
        this._ctx.restore();
    },
    render_gradiated_background: function (width, height, top_color, bottom_color) {
        this.clear(width, height);
        var gradient = this._ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0, top_color);
        gradient.addColorStop(1, bottom_color);
        this._ctx.fillStyle = gradient;
        this._ctx.fillRect(0, 0, width, height);
    },
    render_solid_background: function (width, height, color) {
        this.clear(width, height);
        this._ctx.fillStyle = color;
        this._ctx.fillRect(0, 0, width, height);
    },
    annotate_scaled: function (width, height, x, y, text, scale) {
        var scaled_width = width * scale >= 1 ? width * scale : 1;
        var scaled_height = height * scale >= 1 ? height * scale : 1;
        var text = this._sized_text(this.pointsize, text);
        text.style.color = this.fill;
        text.style.fontWeight = this.font_weight;
        text.style.textAlign = 'center';
        text.style.left = this._sx * x + this._left_adjustment(text, scaled_width) + 'px';
        text.style.top = this._sy * y + this._top_adjustment(text, scaled_height) + 'px';
    },
    tooltip: function (left, top, width, height, name, color, data) {
        if (width < 0) left += width;
        if (height < 0) top += height;
        var wrapper = this._canvas.parentNode,
            target = document.createElement('div');
        target.style.position = 'absolute';
        target.style.left = this._sx * left - 3 + 'px';
        target.style.top = this._sy * top - 3 + 'px';
        target.style.width = this._sx * Math.abs(width) + 5 + 'px';
        target.style.height = this._sy * Math.abs(height) + 5 + 'px';
        target.style.overflow = 'hidden';
        Bluff.Event.observe(target, 'mouseover', function (node) {
            Bluff.Tooltip.show(name, color, data);
            target.className = 'chart_tooltip_image';
        });
        Bluff.Event.observe(target, 'mouseout', function (node) {
            Bluff.Tooltip.hide();
            target.className = '';
        });
        wrapper.appendChild(target);
    },
    circle: function (origin_x, origin_y, perim_x, perim_y, arc_start, arc_end) {
        var radius = Math.sqrt(Math.pow(perim_x - origin_x, 2) + Math.pow(perim_y - origin_y, 2));
        this._ctx.fillStyle = this.fill;
        this._ctx.beginPath();
        var alpha = ((arc_start || 0) * Math.PI) / 180;
        var beta = ((arc_end || 360) * Math.PI) / 180;
        if (arc_start !== undefined && arc_end !== undefined) {
            this._ctx.moveTo(
                this._sx * (origin_x + radius * Math.cos(beta)),
                this._sy * (origin_y + radius * Math.sin(beta))
            );
            this._ctx.lineTo(this._sx * origin_x, this._sy * origin_y);
            this._ctx.lineTo(
                this._sx * (origin_x + radius * Math.cos(alpha)),
                this._sy * (origin_y + radius * Math.sin(alpha))
            );
        }
        this._ctx.arc(this._sx * origin_x, this._sy * origin_y, this._sx * radius, alpha, beta, false);
        this._ctx.fill();
    },
    line: function (sx, sy, ex, ey) {
        this._ctx.strokeStyle = this.stroke;
        this._ctx.lineWidth = this.stroke_width;
        this._ctx.beginPath();
        this._ctx.moveTo(this._sx * sx, this._sy * sy);
        this._ctx.lineTo(this._sx * ex, this._sy * ey);
        this._ctx.stroke();
    },
    polyline: function (points) {
        this._ctx.fillStyle = this.fill;
        this._ctx.globalAlpha = this.fill_opacity || 1;
        try {
            this._ctx.strokeStyle = this.stroke;
        } catch (e) {}
        var x = points.shift(),
            y = points.shift();
        this._ctx.beginPath();
        this._ctx.moveTo(this._sx * x, this._sy * y);
        while (points.length > 0) {
            x = points.shift();
            y = points.shift();
            this._ctx.lineTo(this._sx * x, this._sy * y);
        }
        this._ctx.fill();
    },
    rectangle: function (ax, ay, bx, by) {
        var temp;
        if (ax > bx) {
            temp = ax;
            ax = bx;
            bx = temp;
        }
        if (ay > by) {
            temp = ay;
            ay = by;
            by = temp;
        }
        try {
            this._ctx.fillStyle = this.fill;
            this._ctx.fillRect(this._sx * ax, this._sy * ay, this._sx * (bx - ax), this._sy * (by - ay));
        } catch (e) {}
        try {
            this._ctx.strokeStyle = this.stroke;
            if (this.stroke !== 'transparent')
                this._ctx.strokeRect(this._sx * ax, this._sy * ay, this._sx * (bx - ax), this._sy * (by - ay));
        } catch (e) {}
    },
    _left_adjustment: function (node, width) {
        var w = this._element_size(node).width;
        switch (this.gravity) {
            case 'west':
                return 0;
            case 'east':
                return width - w;
            case 'north':
            case 'south':
            case 'center':
                return (width - w) / 2;
        }
    },
    _top_adjustment: function (node, height) {
        var h = this._element_size(node).height;
        switch (this.gravity) {
            case 'north':
                return 0;
            case 'south':
                return height - h;
            case 'west':
            case 'east':
            case 'center':
                return (height - h) / 2;
        }
    },
    _text_container: function () {
        var wrapper = this._canvas.parentNode;
        if (wrapper.className === this.klass.WRAPPER_CLASS) return wrapper;
        wrapper = document.createElement('span');
        wrapper.className = this.klass.WRAPPER_CLASS;
        wrapper.style.position = 'relative';
        wrapper.style.display = 'block';
        wrapper.style.border = 'none';
        wrapper.style.padding = '0 0 10px 0';
        wrapper.style.width = this._canvas.width + 'px';
        wrapper.style.height = this._canvas.height + 'px';
        this._canvas.parentNode.insertBefore(wrapper, this._canvas);
        wrapper.appendChild(this._canvas);
        return wrapper;
    },
    _sized_text: function (size, content) {
        var text = this._text_node(content);
        text.style.fontFamily = this.font;
        text.style.fontSize = typeof size === 'number' ? size + 'px' : size;
        return text;
    },
    _text_node: function (content) {
        var div = document.createElement('div');
        div.className = this.klass.TEXT_CLASS;
        div.style.position = 'absolute';
        div.appendChild(document.createTextNode(content));
        this._text_container().appendChild(div);
        return div;
    },
    _remove_node: function (node) {
        node.parentNode.removeChild(node);
        if (node.className === this.klass.TARGET_CLASS) Bluff.Event.stopObserving(node);
    },
    _element_size: function (element) {
        var display = element.style.display;
        return display && display !== 'none'
            ? {
                  width: element.offsetWidth,
                  height: element.offsetHeight,
              }
            : {
                  width: element.clientWidth,
                  height: element.clientHeight,
              };
    },
});
Bluff.Event = {
    _cache: [],
    _isIE: window.attachEvent && navigator.userAgent.indexOf('Opera') === -1,
    observe: function (element, eventName, callback, scope) {
        var handlers = Bluff.map(this._handlersFor(element, eventName), function (entry) {
            return entry._handler;
        });
        if (Bluff.index(handlers, callback) !== -1) return;
        var responder = function (event) {
            callback.call(scope || null, element, Bluff.Event._extend(event));
        };
        this._cache.push({
            _node: element,
            _name: eventName,
            _handler: callback,
            _responder: responder,
        });
        if (element.addEventListener) element.addEventListener(eventName, responder, false);
        else element.attachEvent('on' + eventName, responder);
    },
    stopObserving: function (element) {
        var handlers = element ? this._handlersFor(element) : this._cache;
        Bluff.each(handlers, function (entry) {
            if (entry._node.removeEventListener) entry._node.removeEventListener(entry._name, entry._responder, false);
            else entry._node.detachEvent('on' + entry._name, entry._responder);
        });
    },
    _handlersFor: function (element, eventName) {
        var results = [];
        Bluff.each(this._cache, function (entry) {
            if (element && entry._node !== element) return;
            if (eventName && entry._name !== eventName) return;
            results.push(entry);
        });
        return results;
    },
    _extend: function (event) {
        if (!this._isIE) return event;
        if (!event) return false;
        if (event._extendedByBluff) return event;
        event._extendedByBluff = true;
        var pointer = this._pointer(event);
        event.target = event.srcElement;
        event.pageX = pointer.x;
        event.pageY = pointer.y;
        return event;
    },
    _pointer: function (event) {
        var docElement = document.documentElement,
            body = document.body || {
                scrollLeft: 0,
                scrollTop: 0,
            };
        return {
            x: event.pageX || event.clientX + (docElement.scrollLeft || body.scrollLeft) - (docElement.clientLeft || 0),
            y: event.pageY || event.clientY + (docElement.scrollTop || body.scrollTop) - (docElement.clientTop || 0),
        };
    },
};
if (Bluff.Event._isIE)
    window.attachEvent('onunload', function () {
        Bluff.Event.stopObserving();
        Bluff.Event._cache = null;
    });
if (navigator.userAgent.indexOf('AppleWebKit/') > -1) window.addEventListener('unload', function () {}, false);
Bluff.Tooltip = new JS.Singleton({
    LEFT_OFFSET: -57,
    TOP_OFFSET: -75,
    DATA_LENGTH: 8,
    CLASS_NAME: 'chart_tooltip',
    setup: function () {
        this._tip = document.createElement('div');
        this._tip.className = this.CLASS_NAME;
        this._tip.style.backgroundcolor = '#fcc';
        this._tip.style.position = 'absolute';
        this.hide();
        document.body.appendChild(this._tip);
        Bluff.Event.observe(
            document.body,
            'mousemove',
            function (body, event) {
                this._tip.style.left = event.pageX + this.LEFT_OFFSET + 'px';
                this._tip.style.top = event.pageY + this.TOP_OFFSET + 'px';
            },
            this
        );
    },
    show: function (name, color, data) {
        this._tip.innerHTML = '<div style="position:relative;"><span class="label">' + name + '</span>';
        this._tip.innerHTML += '<span class="arrow"></span></div>';
        this._tip.style.display = '';
    },
    hide: function () {
        this._tip.style.display = 'none';
    },
});
Bluff.Event.observe(window, 'load', Bluff.Tooltip.method('setup'));
